module.exports = __webpack_public_path__ + "static/media/bn.11925107.png";